/* globals adstackData, googletag, Cookies, pbjs, headerBiddingData, hmUtils */
/* googletag.cmd is the recommended way of handling async to queue callbacks for when GPT is ready.
They are guaranteed to execute once the API is set up.*/

import {
	dfpAdSlotPath,
	isMobile,
	getDocereeBidderConfig,
	getPulsePointBidderConfig,
	getDeepIntentBidderConfig,
	getDefinedAdSlot,
	docereePrebidSettings,
	initPrebidSettings,
	adSetTargeting,
	getLassoBidderConfig,
	lassoPrebidSettings,
	getAdSlotDeviceSizes,
	getOguryBidderConfig,
	getPulsePointSettings,
	sendDataToDatalayer
} from './ad-stack-utils.js';
import {AdStackLogger} from './loggers';
import { ISMController } from './ism/ism-controller';

( function () {
	if( !window.googletag ) {
		console.error( 'googletag not defined', 'error' );
		return false;
	}
	if( !window.adstackData ) {
		console.error( 'Ad Stack settings data not found', 'error' );
		return false;
	}
	const logger = new AdStackLogger();
	window.adstackData.logger = logger;
	let lineItemIds = []; // array to keep track of line item IDs
	let timeStamp = {}; // set up objet to hold refresh ids for continuous ad refresh
	// Determine refreshInterval based on window.dartService or fallback to adstackData.refresh_interval with a default of 10000.
	let refreshInterval = adstackData.refresh_interval ? adstackData.refresh_interval * 1000 : 10000;
	refreshInterval = window.darService ? window.darService.adstackData.refresh_interval * 1000 : refreshInterval;
	let delayAds = {}; // delay ads until we have lid of the previous ad
	let isLeaderBoardLoaded = false, isStickyFooterLoaded = false, adRefreshObserver, clonedInViewRefreshEntries = [];
	let excludeAdsRefresh = [ 'OOP_skin', 'OOP_prestitial', 'prestitial', 'box_bonus1', 'box_bonus2', 'box_bonus3' ];
	let excludeNativeAdRefresh = adstackData.exclude_native_ad_refresh;
	let headerBiddingPartners = window.headerBiddingData && headerBiddingData['ad_parteners'] ? headerBiddingData['ad_parteners'] : [];
	let rafTimeOuts = { 'contentReady' : [] };
	let adReTargeting = { 'timer' : '', 'timerCounter' : 0 };
	let allProvidersData = false, anchorAdSlot;
	if( excludeNativeAdRefresh ) {
		excludeAdsRefresh.push( 'native_1' );
	}
	const IntObserverOptions = {
		threshold:  typeof headerBiddingData !== 'undefined' && headerBiddingData.in_view_percentage ? parseInt( headerBiddingData.in_view_percentage ) / 100 : 0.25,
	};

	googletag.cmd.push( function () {
		// set global/page level targeting //
		adSetTargeting( typeof adstackData !== 'undefined' && adstackData ?
			adstackData.global_targeting : {}, googletag.pubads() );
		window.googletag.pubads().enableSingleRequest();
		window.googletag.pubads().disableInitialLoad();
		window.googletag.enableServices();
		let oracleCookie;
		oracleIdTargeting().then( function ( value ) { // to ensure oracle cookie ID is always sent with ad requests.
			oracleCookie = value;
		} ).catch( function () {} ).finally( function () {
			oracleCookie && adSetTargeting( {'oraid': [oracleCookie]}, googletag.pubads() );
			initDFP();
		} );

		googletag.pubads().addEventListener( 'slotRenderEnded', function ( event ) {
			//Store the line items and pass info with the subsequent ad requests
			let slot = event.slot;
			if ( lineItemIds.indexOf( event.lineItemId ) === -1 ) {
				lineItemIds.push( event.lineItemId );
			}
			/* On desktop, we delay in_article_1 and box_1. Both are requested after leaderboard_top is rendered.
			On mobile, we delay in_article_1. It is requested after stickyfooter ad is rendered. */
			const adUnitPath = slot.getAdUnitPath().split( '/' );
			const adSlotName = adUnitPath[adUnitPath.length - 1];
			if( typeof hmUtils !== 'undefined' && !hmUtils.isMobile() && adSlotName === 'leaderboard_top' ) {
				isLeaderBoardLoaded = true;
			}
			if( typeof hmUtils !== 'undefined' && hmUtils.isMobile() && adSlotName === 'stickyfooter' ) {
				isStickyFooterLoaded = true;
			}
			if( isLeaderBoardLoaded ) {
				isLeaderBoardLoaded = true;
				delayAds['box_1'] && delayAds['box_1']();
				delete delayAds['box_1'];
				delayAds['in_article_1'] && delayAds['in_article_1']();
				delayAds['in_article_1'] && delete delayAds['in_article_1'];
			}
			if( isStickyFooterLoaded ) {
				delayAds['in_article_1'] && delayAds['in_article_1']();
				delete delayAds['in_article_1'];
			}
		} );
		/* Observe an ad slot for refresh only after its rendered on first page load */
		googletag.pubads().addEventListener( 'slotOnload', function ( event ) {
			let div = document.getElementById( event.slot.getSlotElementId() );
			if ( div && adRefreshObserver && !div.dataset.observeRefresh ) {
				div.setAttribute( 'data-observe-refresh', true );
				adRefreshObserver.observe( div );
			}
		} );
	} );

	/** Making sure ad requests occur after the first paint occurs and when the first dfp-ad div is
	 found using requestAnimationFrame. Check if lazy load is enabled.
	 */
	function ContentReady() {
		// Check if the document has finished loading and the document has been parsed and the first dpf ad div element exist
		if ( ( document.readyState == 'interactive' || document.readyState == 'complete' ) && document.querySelector( '.dfp-ad' ) ) {
			let dfpInterstitialAd = window.darService ? window.darService.adstackData.dfp_interstitial_ad : adstackData.dfp_interstitial_ad;
			if ( dfpInterstitialAd ) {
				defineInterstitialAd();
			}
			if( adstackData.dfp_bottom_anchor_ad || adstackData.dfp_top_anchor_ad ) {
				displayAnchorAd();
			}
			let dfpLazyload = window.darService ? window.darService.adstackData.dfp_lazyload : adstackData.dfp_lazyload;
			if( dfpLazyload ) {
				lazyLoadAds();
			} else {
				renderAllAds();
			}
			cpnSetTargeting(); // To ensure onetrust is rendered
			setTargetingDrugMonograph(); // set targeting for drug monograph pages
			/* If refresh all(Standard, HeaderBidding) ads is enabled */
			// refreshAllAds to window.darService.adstackData.refresh_all_ads if window.darService is available, otherwise it uses adstackData.refresh_all_ads.
			let refreshAllAds = window.darService ? window.darService.adstackData.refresh_all_ads : adstackData.refresh_all_ads;
			if ( refreshAllAds  ) {
				configureAdRefresh();
			}
			/* When both ad refresh is off and we need to still refresh ads on certain pages like slideshow, quizz etc */
			if( !refreshAllAds  ) {
				registerRefreshADEvent();
			}
			for( let id in rafTimeOuts['contentReady'] ) {
				window.cancelAnimationFrame( id );
			}
			// Return so that we don't call requestAnimationFrame() again
			return;
		}
		// If the element isn't found, run ready() again at the next paint
		let id = window.requestAnimationFrame( ContentReady );
		rafTimeOuts['contentReady'].push( id );
	}
	/**
	 Function to render All Ads on page load. Used GPT's inbuilt lazy load to achieve non-lazy effect.
	 */
	function renderAllAds( adDiv ) {
		adDiv = adDiv || '.dfp-ad';
		googletag.cmd.push( function () {
			document.querySelectorAll( adDiv ).forEach( function ( ad ) {
				renderAdSlot( ad );
			} );
		} );
	}

	/**
	 Implement lazyload using IntersectionObserver method
	 root points to viewport.
	 threshold is set to 0.25, which means intersection ratio is 0.25(Once its partially visible on the screen). Once that is crossed, it will execute the callback.
	 To-DO: To move in_view_percentage setting to new ad stack plugin
	 */
	function lazyLoadAds( adDiv ) {
		adDiv = adDiv || '.dfp-ad';
		googletag.cmd.push( function () {
			var observer = new IntersectionObserver( handleIntersect, IntObserverOptions );
			//observe the ad element
			document.querySelectorAll( adDiv ).forEach( function ( ad ) {
				observer.observe( ad );
			} );
		} );
	}
	function defineInterstitialAd() {
		let interstitialSlot = '';
		googletag.cmd.push( function () {
			let interstitialAD = dfpAdSlotPath();
			// Define a web interstitial ad slot.
			interstitialSlot = googletag.defineOutOfPageSlot(
				interstitialAD,
				googletag.enums.OutOfPageFormat.INTERSTITIAL );
			// Slot returns null if the page or device does not support interstitials.
			if ( interstitialSlot ) {
				interstitialSlot.addService( googletag.pubads() );
			}
		} );
		// interstitialSlot.addService( googletag.pubads() );
		googletag.cmd.push( function () {
			googletag.display( interstitialSlot );
			googletag.pubads().refresh();
		} );

	}

	/**
	 *  Callback called whenever visibility of the target element changes i.e. its being observed
	 *  Check if it intersects with the root( in our case, its the viewport)
	 *  Refer to `Logic related to in-article-1 and box-1 ad slots` section from the README.md file.
	 * @param entries
	 * @param observer
	 */
	function handleIntersect( entries, observer ) {
		entries.forEach( function ( entry ) {
			if ( entry.target ) {
				let dfpAdSize = getAdSlotDeviceSizes( entry.target );
				if ( entry.isIntersecting && dfpAdSize ) {
					renderAdSlot( entry.target );
					observer.unobserve( entry.target );
				}
			}
		} );
	}

	/**
	 * Slot info is added to ad div markup the form of data attributes
	 * Define an ad slot with ad slot path, sizes, id.
	 * Pick up size based on the viewport. If size not present for a particular viewport,
	 * do not fetch the ad.
	 * Set slot level targeting
	 * Refresh/render ad
	 * @param adDiv
	 */
	function renderAdSlot( adDiv ) {
		let dfpAdPath = dfpAdSlotPath() + adDiv.dataset.adSlotName;
		let adSlotName = adDiv.dataset.adSlotName;
		let dfpAdSize = getAdSlotDeviceSizes( adDiv );
		if ( dfpAdSize ) {
			let targeting = JSON.parse( adDiv.dataset.adTargeting || '{}' );
			let theAd;
			if ( adDiv.dataset.adOutOfPage ) {
				theAd = googletag.defineOutOfPageSlot( dfpAdPath, adDiv.id );
			} else {
				theAd = googletag.defineSlot( dfpAdPath, dfpAdSize, adDiv.id );
			}
			adSetTargeting( targeting, theAd );
			theAd.addService( googletag.pubads() );
			theAd.setCollapseEmptyDiv( true );
			googletag.display( adDiv.id );
			headerBiddingPartners.length && setPrebidConfig( theAd, dfpAdSize, adDiv );
			/* Used JS closures, to maintain variable scoping. This fn can still access vars declared in its outer function even when they are not in scope.
			This fn is also being used on refresh to refresh ads. Hence, targeting like lid and crlid which needs to be different on refresh are part of this fn */
			let refreshAdSlot = function() {
				let crlId = typeof hmUtils !== 'undefined' && hmUtils.generateUUID();
				adSetTargeting( {'allProvidersData': [ allProvidersData ] },
					theAd );
				adSetTargeting( {'lid': getLIDTargeting()},
					theAd );
				adSetTargeting( {'crlid': crlId },
					theAd );
				if ( headerBiddingPartners.length ) {
					getPrebidBids( theAd );
				} else {
					googletag.pubads().refresh( [theAd], {changeCorrelator: false} );
				}
				sendDataToDatalayer( {
					'GAM_Correlation_Id': crlId,
					'event': 'correlationIdRefresh'
				} );
			};
			/* Assign the above function to each defined slot. So at the time of refresh, we already have all info we need to
			* set its respective targeting */
			theAd['refresh'] = {};
			theAd['refresh'][adSlotName] = refreshAdSlot;
			adDiv.classList.add( 'rendered' );
			/* only when lazyload is enabled, it makes sense to send line item ID of previous ad slot with the current ad request*/
			let dfpLazyload = window.darService ? window.darService.adstackData.dfp_lazyload : adstackData.dfp_lazyload;
			if( delayAdSlot( adSlotName ) && dfpLazyload ) {
				delayAds[adSlotName] = refreshAdSlot;
			} else {
				refreshAdSlot();
			}
		}
	}
	/**
	 * Attempting to intercept the CPN query string parameter and set targeting to pass on to GAM.
	 * Based upon my investigation I believe tht this is a page level action and not an independent
	 * adSlot/line item based system.
	 *
	 * @see https://haymarket.atlassian.net/browse/ENG-2216
	 */
	function cpnSetTargeting() {
		const hmUtils = window.hmUtils;
		const cpn = hmUtils.getCPNValue();
		if ( cpn ) {
			adSetTargeting( {'cpn': [cpn]}, googletag.pubads() );
			hmUtils.setDataLayerTarget( 'User.CampaignCodes', cpn );
		}
	}

	/**
	 * Configure prebid ad partner based upon the header bidder settings.
	 * Not every ad slot is configured to make a request to Prebid.Hence, we check for bids.length
	 * If a slot has its required data, its added to pbjs.
	 * @param theAd - GPT Ad slot
	 * @param adSize - Ad size
	 * @param adDiv - Ad Div element
	 * @returns {boolean}
	 */
	function setPrebidConfig( theAd, adSize, adDiv ) {
		let bids = [].concat( getDeepIntentBidderConfig( adDiv ), getPulsePointBidderConfig( adDiv, adSize ),
			getDocereeBidderConfig( adDiv ), getLassoBidderConfig( adDiv ), getOguryBidderConfig( adDiv ) );
		if ( bids.length ) {
			const adUnits = [{
				code: theAd.getAdUnitPath(),
				mediaTypes: {
					banner: {
						sizes: adSize
					}
				},
				bids: bids
			}];
			if ( typeof pbjs !== 'undefined' ) {
				pbjs.que.push( function () {
					pbjs.setConfig( initPrebidSettings() );
					headerBiddingData['ad_parteners'].indexOf( 'doceree' ) > -1 && docereePrebidSettings();
					headerBiddingData['ad_parteners'].indexOf( 'lasso' ) > -1 && lassoPrebidSettings();
					headerBiddingData['ad_parteners'].indexOf( 'pulsepoint' ) > -1 && getPulsePointSettings();
					pbjs.addAdUnits( adUnits );
					headerBiddingData.hb_deepintent_identity_pixel && pbjs.refreshUserIds();
				} );
			}
		}
	}

	/**
	 * Make a request to each ad partner configured to get bids using requestBids fn
	 * initAdserver is the callback after the response has returned.It matches AdUnits that have returned from the auction
	 * to a GPT ad slot and adds the hb_targeting attributes to the slot, so they are sent to GAM using setTargetingForGPTAsync
	 * bidsBackHandler is called either when all bids are back, or when the timeout is reached.
	 * refreshAds - call to GPT ad server
	 * If any ad slot is not configured with any prebid partner, then it should call the standard refresh method.
	 */
	function getPrebidBids( theAd ) {
		const PREBID_TIMEOUT = 1000;
		if ( typeof pbjs !== 'undefined' ) {
			pbjs.que.push( function () {
				pbjs.requestBids( {
					adUnitCodes: [theAd.getAdUnitPath()],
					bidsBackHandler: function () {
						googletag.cmd.push( function () {
							pbjs.que.push( function () {
								pbjs.setTargetingForGPTAsync( [theAd.getAdUnitPath()] );
								googletag.pubads().refresh( [theAd], { changeCorrelator: false } );
							} );
						} );
					},
					timeout: PREBID_TIMEOUT
				} );
			} );
			return false;
		}
		googletag.pubads().refresh( [theAd], { changeCorrelator: false } );
	}
	/**
	 * To get LID value
	 */
	function getLIDTargeting() {
		return lineItemIds.length == 0 ? [null] : lineItemIds;
	}

	/**
	 * If ISM is enabled, execute ISM Flow.
	 * lyticsData - lytics localized var.Used to check if lytics plugin is enabled.
	 * Set lytics targeting
	 * Check if first ad div is rendered and call ad render fn
	 * use of await - Ensuring every lytics segments are present before first ad call is made.
	 * @returns {Promise<void>}
	 */
	async function initDFP() {
		if( adstackData.ism && adstackData.ism.enabled ) {
			const ism = new ISMController();
			adstackData.ism = Object.assign( adstackData.ism, ism );
			fetchISMProviders();
		} else {
			// Registering rendering ad feature as the ad div is rendered //
			let id = window.requestAnimationFrame( ContentReady );
			rafTimeOuts['contentReady'].push( id );
		}
	}
	/**
	 * Render ad slot div which was dynamically added to the page, ex, Quiz
	 * @param adDiv - Ad div element
	 */
	adstackData.renderDynamicAdSlot = function ( adDiv ) {
	//	dfpInterstitialAd to window.darService.adstackData.dfp_interstitial_ad if window.darService is available, otherwise it uses adstackData.dfp_interstitial_ad.
		let dfpInterstitialAd = window.darService ? window.darService.adstackData.dfp_interstitial_ad : adstackData.dfp_interstitial_ad;
		if ( dfpInterstitialAd ) {
			defineInterstitialAd();
		}
		let dfpLazyload = window.darService ? window.darService.adstackData.dfp_lazyload: adstackData.dfp_lazyload;
		if ( dfpLazyload ) {
			lazyLoadAds( adDiv );
		} else {
			renderAllAds( adDiv );
		}
	};
	/**
	 * Activate this feature only if all ads refresh setting is on.
	 * As and when ad comes into view, refresh(make an ad call again) the ad.
	 */
	function configureAdRefresh() {
		adRefreshObserver = new IntersectionObserver( handleAdsRefresh,  { threshold: 0.50,
			rootMargin: isMobile() ? '0px' : '-152px' } );
	}
	/**
	 * Callback called after the ad div element is in view.
	 * `clonedInViewRefreshEntries` is an array which keeps track of currently in-view ad divs.
	 * If its not in-view, we splice the respective entry from the array.
	 * @param entries
	 */
	function handleAdsRefresh( entries ) {
		entries.forEach( function ( entry ) {
			const adSlotName = entry.target.dataset ? entry.target.dataset.adSlotName : '';
			if ( entry.isIntersecting && entry.target ) {
				const matchedSlot = getDefinedAdSlot( entry.target );
				if( adSlotName && matchedSlot.length && ! excludeAdsRefresh.includes( adSlotName ) ) {
					timeStamp[adSlotName] = window.requestAnimationFrame( function ( timestamp ) {
						matchedSlot[0].startTime = timestamp;
						clonedInViewRefreshEntries.push( entry );
						refreshInViewAds( timestamp, matchedSlot[0] );
					} );
				}
			} else {
				let slot = clonedInViewRefreshEntries.findIndex( function( item ) {
					return item.target.dataset.adSlotName == adSlotName;
				} );
				slot > -1  && clonedInViewRefreshEntries.splice( slot, 1 );
				window.cancelAnimationFrame( timeStamp[adSlotName] );
			}
		} );
	}

	/**
	 * Function to refresh ads in view after a defined time interval. Used requestanimation frame as it is follows the time interval.
	 * @param now
	 * @param adSlot
	 */
	function refreshInViewAds( now, adSlot ) {
		const adUnitPath = adSlot.getAdUnitPath().split( '/' );
		const adSlotName = adUnitPath[adUnitPath.length - 1];
		if( now - adSlot.startTime >= refreshInterval ) {
			adSlot.startTime = now;
			adSlot.setTargeting( 'refresh', [ true ] );
			adSlot['refresh'] && adSlot['refresh'][adSlotName] && adSlot['refresh'][adSlotName]();
		}
		timeStamp[adSlotName] = window.requestAnimationFrame( function ( timestamp ) {
			refreshInViewAds( timestamp, adSlot );
		} );
	}

	/**
	 * To decide if an ad slot should be delayed.
	 * On desktop, we delay in_article_1 and box_1. box_1 & in_article_1 are requested after leaderboard_top is rendered.
	 * on mobile, we delay in_article_1. It is requested after stickyfooter ad is rendered.
	 * @param adSlotName
	 * @returns {boolean}
	 */
	function  delayAdSlot( adSlotName ) {
		if( typeof hmUtils !== 'undefined' && !hmUtils.isMobile()  ){
			if( !isLeaderBoardLoaded && ['box_1', 'in_article_1'].includes( adSlotName ) ) {
				return true;
			}
		} else {
			if( !isStickyFooterLoaded && adSlotName == 'in_article_1' ) {
				return true;
			}
		}
	}
	/**
	 * Register a custom event to refresh ads when both refresh ad setting is off
	 * Use `document.dispatchEvent( window.adstackData.refreshAdEvent );` to refresh ads
	 */
	function registerRefreshADEvent(){
		adstackData.refreshAdEvent = new CustomEvent( 'refreshAdEvent', {} );
		// To trigger the event Listener
		document.addEventListener( 'refreshAdEvent', ()=>{
			configureAdRefresh();
			document.querySelectorAll( '.dfp-ad.rendered' ).forEach( function ( ad ) {
				if ( adRefreshObserver && !ad.dataset.observeRefresh ) {
					ad.setAttribute( 'data-observe-refresh', true );
					adRefreshObserver.observe(  ad );
				}
			} );
		} );
	}

	/**
	 * RequestAnimation frame pauses the ad refresh when a tab is inactive but if we return to it after the time interval has elapsed(ex, 30s),
	 * it immediately refreshes the ads. `visibilitychange` event is added to alter this behaviour. When the tab is inactive, we cancel all requests
	 * to animation frame. When we return to it, we use `clonedInViewRefreshEntries` array to activate refresh only for the entries which were in view
	 * when the user left the tab.This is because, intersection observer is only activated on scroll. And, we still want refresh to work if the user
	 * doesn't scroll after returning to the active tab.
	 */
	document.addEventListener( 'visibilitychange', handleVisibilityChange, false );
	function handleVisibilityChange () {
		if ( document.hidden ) {
			for ( let ad in timeStamp ) {
				window.cancelAnimationFrame( timeStamp[ad] );
			}
		} else {
			handleAdsRefresh( clonedInViewRefreshEntries );
			clonedInViewRefreshEntries.length = 0;
		}
	}
	/**
	 * Event listener setGAMTargeting is used to set GAM targeting
	 * For any targeting that needs to be set  from any other Js file, use
	 * `let targetingEvent = new CustomEvent( 'setGAMTargeting', {'detail' : targeting } );
	 *  document.dispatchEvent( targetingEvent );`
	 *  targeting is an object containing info in the form of key value pair.
	 *  This will set the appropriate targeting on the ad request.
	 */
	document.addEventListener( 'setGAMTargeting', ( event )=>{
		googletag.cmd.push( function () {
			adSetTargeting( event.detail, googletag.pubads() );
		} );
	} );

	/**
	 * Call all Indentitiy Service providers concurrently using Promise.race within a set timeout.
	 * In either state(resolved/rejected), it will continue to execute the ad logic to renders ads.
	 * @param timestamp
	 * @param startTime
	 */
	function fetchISMProviders() {
		Promise.allSettled(
			adstackData.ism.registeredServices()
		).then( function () {} ).catch( function ( value ) {
			console.error( value );
		} ).finally( function() {
			// Registering rendering ad feature as the ad div is rendered //
			let LSData = window.localStorage && window.localStorage.getItem( 'ISMDataStack' );
			LSData = JSON.parse( LSData ) ; //get ISM data stored in LS.
			/* check if resolvedServicesData(all ism providers resolved on Page Load) or ISM data for all providers stored in LS(LSData) or we have received data from
            * all providers(allProvidersData). If yes, set the targeting to true. */
			if( ( adstackData.ism.resolvedServicesData.length === adstackData.ism.services.length )
				|| ( LSData && LSData.length === adstackData.ism.services.length ) )  {
				allProvidersData = true;
			}
			setISMGAMTargetingData();
			adstackData.logger.logDataOnPageLoad();
			let id = window.requestAnimationFrame( ContentReady );
			rafTimeOuts['contentReady'].push( id );
		} );
	}

	/**
	 *  On window load event, set the cookie only if user has opted in.
	 *  A fallback (else) condition added to delete the cookie if user has opted out, in case it is set by some other sources.
	 */
	window.addEventListener( 'load', function () {
		const onetrustStatus = hmUtils && hmUtils.hasUserEnabledOneTrust && hmUtils.hasUserEnabledOneTrust();
		const cpn = hmUtils.getCPNValue();
		if( cpn && onetrustStatus ) {
			Cookies.set( 'adcpn2', cpn, {expires: 20 * 365} );
		} else {
			Cookies.remove( 'adcpn2' );
		}
		/* function called after an interval of 5s to retarget ads */
		if( adstackData.ism && adstackData.ism.enabled ) {
			let timer = setTimeout( function () {
				triggerEventBasedAdReTargeting();
				clearTimeout( timer );
			}, 5000 );
		}
	} );

	/**
	 * Intersection observer to refresh ads that are in view and with class(rendered).
	 * rendered class is applied to all ad slots that are in view and are loaded on page load.
	 * This is to ensure that ads that are not loaded on page load are not retargeted(called again) unnecessarily.
	 */
	function configureAdReTargeting(){
		googletag.cmd.push( function () {
			let retargetingObserver = new IntersectionObserver( function( entries ) { entries.forEach( function ( entry ) {
				const adSlotName = entry.target.dataset ? entry.target.dataset.adSlotName : '';
				if ( entry.isIntersecting && entry.target ) {
					const matchedSlot = getDefinedAdSlot( entry.target );
					const adSlot = matchedSlot[0];
					if( adSlotName && matchedSlot.length && ! excludeAdsRefresh.includes( adSlotName ) ) {
						const adUnitPath = adSlot.getAdUnitPath().split( '/' );
						const adSlotName = adUnitPath[adUnitPath.length - 1];
						adSlot.setTargeting( 'refresh', [ true ] );
						adSlot['refresh'] && adSlot['refresh'][adSlotName] && adSlot['refresh'][adSlotName]();
						retargetingObserver.unobserve( entry.target );
					}
				}
			} ); },  IntObserverOptions );

			document.querySelectorAll( '.dfp-ad.rendered' ).forEach( function ( ad ) {
				retargetingObserver.observe(  ad );
			} );
		} );
	}

	/**
	 * Function which checks if we data from all providers is received. If yes, it saves data in Localstorage and retargets the ads.
	 * If not, it calls itself again every 5s until we have data.
	 * adReTargeting['timerCounter'] - is set so that we break the loop at some point and not wait forever.
	 * If data from all service providers is received on page load within the timeout, no need to retarget. Else, we retarget.
	 * We also retarget when the new data received from a provider is different from the one sent previously(Stored in LS).- hasTargetingChanged is the method to compare
	 * counter to keep track if data from any provider has changed. Ad refresh code is initiated(has to be triggered only once) only if the counter is greater than 0.
	 * set the new targeting and store new data in LS.
	 * disable_ad_retarget - is enabled we do not retarget.
	 */
	function triggerEventBasedAdReTargeting() {
		if ( adstackData.ism.dataStack.length === adstackData.ism.servicesInstances.length || adReTargeting['timerCounter'] > 5 ) {
			if( adstackData.ism.dataStack.length === adstackData.ism.servicesInstances.length ) {
				allProvidersData = true;
			}
			let counter = 0;
			//disableAdRetarget to window.darService.adstackData.ism.disable_ad_retarget if window.darService is available, otherwise it uses adstackData.ism.disable_ad_retarget.
			let disableAdRetarget = window.darService ? window.darService.adstackData.ism.disable_ad_retarget : adstackData.ism.disable_ad_retarget;
			if ( adstackData.ism.resolvedServicesData.length !== adstackData.ism.servicesInstances.length && ! disableAdRetarget ) {
				adstackData.ism.servicesInstances.forEach( function ( service ) {
					if ( !service.hasTargetingChanged() ) {
						counter++;
						service.setIdentityServiceProviderTargeting();
					}
				} );
				if ( counter ) {
					setISMGAMTargetingData( true );
					configureAdReTargeting(); // triggers ad retargeting/refresh code
					if( anchorAdSlot ) {
						let crlId = typeof hmUtils !== 'undefined' && hmUtils.generateUUID();
						anchorAdSlot.setTargeting( 'refresh', [true] ).setTargeting( 'allProvidersData', [allProvidersData] ).setTargeting( 'crlid', [crlId] );
						googletag.pubads().refresh( [ anchorAdSlot] ); // refresh anchor too.
						sendDataToDatalayer( {
							'GAM_Correlation_Id': crlId,
							'event': 'correlationIdRefresh'
						} );
					}
				}
				adReTargeting['timer'] && clearTimeout( adReTargeting['timer'] ); // clear timeout if set
			}
			adstackData.ism.dataStack.forEach( function ( entry ) {
				adstackData.ism.saveDataToLocalStorage( entry ); // store the new data received on page load in LS
			} );
		} else {
			adReTargeting['timerCounter']++;
			adReTargeting['timer'] = setTimeout( function () {
				triggerEventBasedAdReTargeting();
			}, 5000 );
		}
	}
	/**
	 * Display anchor ad slot only on desktop
	 */
	function displayAnchorAd() {
		googletag.cmd.push( function () {
			if ( typeof hmUtils !== 'undefined' ) {
				let adPath, adFormat;
				if ( hmUtils.isMobile() && adstackData.dfp_top_anchor_ad ) {
					adPath = dfpAdSlotPath() + 'top_anchor';
					adFormat = googletag.enums.OutOfPageFormat.TOP_ANCHOR;
				} else if ( !hmUtils.isMobile() && adstackData.dfp_bottom_anchor_ad ) {
					adPath = dfpAdSlotPath() + 'bottom_anchor';
					adFormat = googletag.enums.OutOfPageFormat.BOTTOM_ANCHOR;
				}
				// Define the ad slot
				anchorAdSlot = googletag.defineOutOfPageSlot( adPath, adFormat );
				if ( anchorAdSlot ) {
					anchorAdSlot.addService( googletag.pubads() );
					googletag.display( anchorAdSlot );
					let crlId = typeof hmUtils !== 'undefined' && hmUtils.generateUUID();
					anchorAdSlot.setTargeting( 'allProvidersData', [allProvidersData] ).setTargeting( 'crlid', [crlId] );
					googletag.pubads().refresh( [anchorAdSlot] );
					sendDataToDatalayer( {
						'GAM_Correlation_Id': crlId,
						'event': 'correlationIdRefresh',
					} );
				}
			}
		} );
	}
	/**
	 * On Drug Monograph Pages, when category is present in query-string, update tcs and tc targeting parameters.
	 */
	function setTargetingDrugMonograph() {
		try {
			if( document && document.body && document.body.classList.contains( 'single-hm-drug' ) ) {
				const urlHash = window.location && window.location.hash;
				if ( urlHash ) {
					googletag.cmd.push( function () {
						const category = document.querySelector( '[data-href="' + urlHash + '"]' );
						const parentCategory = category && category.dataset.parent;
						adSetTargeting( {'tcs': urlHash.substring( 1 )}, googletag.pubads() );
						adSetTargeting( {'tc': parentCategory}, googletag.pubads() );
					} );
				}
			}
		} catch ( e ) {
			console.error( e );
		}
	}

	/**
	 * Add oracle cookie ID to GAM Page Level Targeting
	 * Sometimes Oracle Cookie is not set by Oracle at the time when the first ad request is made.
	 * To ensure Oracle cookie is always sent we have added an interval but also setting it in localstorage.
	 * So on next reload, it is available from LS.
	 * timerCounter - To keep looking until the counter is less than 5. Once greater than 5, break it and execute rest of the code.
	 * @see https://haymarket.atlassian.net/browse/PRX-1303
	*/
	function oracleIdTargeting() {
		let timerFn, timerCounter = 1;
		return new Promise( ( resolve )  => {
			try {
				let oracleCookie = window.localStorage && window.localStorage.getItem( 'oracleCookieID' );
				if ( oracleCookie ) {
					resolve( oracleCookie );
				} else {
					timerFn = setInterval(  () => {
						let oracleCookie = window.hmUtils && window.hmUtils.getOracleCookieId();
						if( oracleCookie || timerCounter > 5 ) {
							window.localStorage && window.localStorage.setItem( 'oracleCookieID', oracleCookie );
							clearInterval( timerFn );
							resolve( oracleCookie );
						}
						timerCounter++;
					}, 1000 );
				}
			} catch ( e ) {
				Promise.reject( e );
			}
		} );

	}

	/**
	 * Set GAM targeting data available from all vendors.
	 * Based on the priority assigned to vendors, NPI is sent to GAM.
	 * On retargeting, we do not sent the NPI info again to GAM.
	 * Set the npi in LS and send it to datalayer.
	 * @param reTarget
	 */
	function setISMGAMTargetingData( reTarget = false ) {
		if ( adstackData.ism.gamTargetingData && Object.keys( adstackData.ism.gamTargetingData ).length ) {
			let targeting = {};
			adstackData.ism.gamTargetingData.sort( function( a, b ) {
				return a.priorityOrder - b.priorityOrder;
			} );
			adstackData.ism.gamTargetingData.forEach( function ( value ) {
				if ( Object.keys( value.targetingData ).length && ! reTarget ) {
					if ( value.targetingData.npi && Object.keys( value.targetingData.npi ).length &&
						! Object.prototype.hasOwnProperty.call( targeting, 'npi' ) &&
						! Object.prototype.hasOwnProperty.call( targeting, 'nid' ) ) {
						targeting['amid'] = window.hmUtils && window.hmUtils.sha256( value.targetingData.npi );
						targeting['nid'] = targeting['amid'] && window.hmUtils.truncateNPIHash( targeting['amid'] );
						googletag.cmd.push( function () {
							adSetTargeting( targeting, googletag.pubads() );
						} );
						window.Cookies.set( 'hmNpiId', value.targetingData.npi  );
						let hmi = {};
						hmi['npi'] = targeting['nid'];
						hmi['npiFullHash'] = targeting['amid'];
						hmi['npiValue'] = value.targetingData.npi;
						const hmiData = JSON.stringify( hmi );
						window.localStorage && window.localStorage.setItem( 'hmi', hmiData );
						window.dataLayer = window.dataLayer || [];
						window.dataLayer.push( { 'User.Nid': targeting[ 'amid' ], 'event': 'UserRefresh' } );
						window.hmUtils && window.hmUtils.setDataLayerTarget( 'User.NpiNumber', value.targetingData.npi.toString() );
					}
				}
				let newTargetingData = Object.assign( {}, value.targetingData );
				delete newTargetingData.npi;
				googletag.cmd.push( function () {
					adSetTargeting( newTargetingData, googletag.pubads() );
				} );
			} );
		}
	}
} )();
